//#region src/components/ImageCropper/hooks/getCroppedImg.ts
var e = (e) => new Promise((t, n) => {
	let r = document.createElement("img");
	r.crossOrigin = "anonymous", r.onload = () => t(r), r.onerror = () => n(/* @__PURE__ */ Error("Failed to load image for cropping")), r.src = e;
});
async function t(t, n, { maxWidth: r = 1600, mimeType: i = "image/webp", fileName: a = "cropped.webp" } = {}) {
	let o = await e(t), s = n.width > r ? r / n.width : 1, c = Math.max(1, Math.round(n.width * s)), l = Math.max(1, Math.round(n.height * s)), u = document.createElement("canvas");
	u.width = c, u.height = l;
	let d = u.getContext("2d");
	if (!d) throw Error("Canvas 2D context unavailable");
	d.drawImage(o, n.x, n.y, n.width, n.height, 0, 0, c, l);
	let f = await new Promise((e) => u.toBlob(e, i, .9));
	if (!f) throw Error("Failed to encode cropped image");
	return new File([f], a, { type: f.type });
}
//#endregion
export { t as getCroppedImg };
